<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="BEPF">All those who prefer to whatever degree the hypothetical over what is called reality, finding the real so deplorable that they seek out what may never be, will find here elements for enjoyment. Those optimists who grieve over the shortcomings of existence may like to imagine that better prospects will be created in the future, not least amid the airless deserts of Mars depicted here.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FinchesofMars_1P5.vue?2215a76d